"use client"

import { CircleCheck } from "lucide-react"

import { getMetaLeadFormReadiness } from "@/lib/meta-ads/form-readiness"
import type { MetaLeadForm } from "@/lib/meta-ads/types"

export function MetaAdsFormReadinessChoice({
  form,
  phoneFieldKey,
}: {
  form: MetaLeadForm
  phoneFieldKey: string
}) {
  const readiness = getMetaLeadFormReadiness(form, phoneFieldKey)
  const titleId = `meta-form-choice-${form.id}`

  if (!readiness.configuredPhoneFieldPresent) {
    return (
      <section aria-labelledby={titleId} className="space-y-4 rounded-lg border bg-muted/30 p-5">
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">{form.name}</p>
          <h3 id={titleId} className="text-pretty text-lg font-semibold">
            Step 1: Create an Unrestricted Copy
          </h3>
          <p className="text-sm text-muted-foreground">
            This form does not contain the phone field Versafy needs. The copy adds it
            so new leads can become callbacks. Your current form and ad stay unchanged;
            after creation, Versafy shows exactly where to select the copy.
          </p>
        </div>
      </section>
    )
  }

  if (readiness.deliveryMode !== "targeted_ads_only") return null

  return (
    <section aria-labelledby={titleId} className="space-y-4 rounded-lg border bg-muted/30 p-5">
      <div className="space-y-2">
        <p className="text-sm text-muted-foreground">{form.name}</p>
        <p className="flex items-center gap-2 text-sm font-medium text-emerald-700">
          <CircleCheck aria-hidden="true" className="h-4 w-4" />
          <span>Live-ad leads already work</span>
        </p>
        <h3 id={titleId} className="text-pretty text-lg font-semibold">
          Step 1: Create an Unrestricted Copy
        </h3>
        <p className="text-sm text-muted-foreground">
          Create this copy so submissions from Meta&apos;s testing tool, ad previews,
          and shared form links can reach Versafy. Your current form and ad stay
          unchanged; after creation, Versafy shows exactly where to select the copy.
        </p>
      </div>
    </section>
  )
}
